import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "@hi/ui/dist/locale/lang/en";
import zhLocale from "@hi/ui/dist/locale/lang/zh-CN";
import ENPLUS from "@hi/ui-plus/dist/lang/en";
import ZHPLUS from "@hi/ui-plus/dist/lang/zh-CN";
import EN from "./lang/en.json";
import ZH from "./lang/zh.json";
import { initLanguage } from "@/config/index";

Vue.use(VueI18n);
const lang = localStorage.getItem("lang") || initLanguage;
// 设置语言
enLocale.el.pagination.pagesize = '/ Page'
const messages = {
  en: {
    ...EN,
    ...ENPLUS,
    ...enLocale,
  },
  zh: {
    ...ZH,
    ...ZHPLUS,
    ...zhLocale,
  },
};

const locale = lang;
// 创建国际化实例
const i18n = new VueI18n({
  locale,
  messages,
});

export default i18n;
